module.exports = __webpack_public_path__ + "img/a4c73577309d3afafc296d63ebfb855c.svg";